import TableEntityBase from "./TableEntityBase";

export default class Login extends TableEntityBase {
    Type: string|null = null;
    Name: string|null = null;
    User: string|null = null;
    Password: string|null = null;
}